import { render, staticRenderFns } from "./sizeNotMatchingIcon.vue?vue&type=template&id=3d8be64b"
import script from "./sizeNotMatchingIcon.vue?vue&type=script&lang=js"
export * from "./sizeNotMatchingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports